// Règles de réservation d'un article, opposées à chaque salarié : nombre de
// réservations actives par salarié. Les quotas de semaines par saison se
// règlent sur la collection (cf. seasonQuotas). Portage de
// Core::Catalog::BookingRules (yeati-api) : l'API fait foi, ce module garde
// les mêmes contrôles et les mêmes messages pour bloquer l'enregistrement
// avant l'envoi.

import type { CatalogBookingRules } from "../types/catalog.api.types";

export type BookingRules = { max_bookings_per_employee: number | null };

export const EMPTY_BOOKING_RULES: BookingRules = { max_bookings_per_employee: null };

const toIntegerOrNull = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

/** Lit les règles servies par l'API (ou un brouillon), sans jamais lever. */
export const normalizeBookingRules = (raw: unknown): BookingRules => {
  if (typeof raw !== "object" || raw === null) return EMPTY_BOOKING_RULES;
  const { max_bookings_per_employee: max } = raw as Record<string, unknown>;
  return { max_bookings_per_employee: toIntegerOrNull(max) };
};

export const hasBookingRules = (rules: BookingRules): boolean =>
  rules.max_bookings_per_employee !== null;

const isPositiveInteger = (value: number | null): boolean =>
  value !== null && Number.isInteger(value) && value > 0;

/** Mêmes contrôles que `BookingRules#configuration_errors`. */
export const bookingRulesErrors = (rules: BookingRules): string[] =>
  rules.max_bookings_per_employee !== null && !isPositiveInteger(rules.max_bookings_per_employee)
    ? ["le nombre de réservations par salarié doit être un entier supérieur à 0"]
    : [];

/** Première erreur, formulée pour un bouton d'enregistrement bloqué. */
export const bookingRulesError = (raw: unknown): string | null => {
  const [first] = bookingRulesErrors(normalizeBookingRules(raw));
  return first ? `Règles de réservation : ${first}` : null;
};

/** Payload API : des règles vides effacent celles déjà enregistrées. */
export const toApiBookingRules = (raw: unknown): CatalogBookingRules => ({ max_bookings_per_employee: normalizeBookingRules(raw).max_bookings_per_employee });
